{
  "footerAboutLink": "Acerca de RebelBase",
  "footerWorkWithUsLink": "Trabaja con  nosotros",
  "footer5DayChallLink": "Reto de 5 días",
  "footerContactLink": "Contacta con nosotros",
  "footerFAQLink": "FAQ",
  "footerPrivacyLink": "Política de privacidad",
  "footerTermsLink": "Términos de servicio",
  "footerWhoWeAreTitle": "Quiénes somos",
  "footerContactTitle": "Contacto",
  "footerPrivacyTermsTitle": "Política de privacidad y Términos de uso",
  "footerSubscribeTopMessage": "Suscríbete para más información.",
  "footerSubscribeBottomMessage": "Consigue un folleto sobre el reto de 5 días de forma gratuita.",
  "footerSubscribeButton": "suscribir",
  "footerEmail": "email"
}
